module.exports = __webpack_public_path__ + "static/GPmain4-d91b141ff1867f347d7b25c5ca7e193f.png";